// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"503114d7","453":"9b41687b","667":"57402ab9"}[chunkId] + ".chunk.js";
};